import React, { useState, useEffect } from "react";
import minusIcon from "../../../../assets/img/careers/Layer_x0020_1.svg";
import plusIcon from "../../../../assets/img/careers/Vector.svg";
import "./SideMenu.css";
const SideMenu = ({ menuData, selectedKey, onSelect }) => {
  const [openSections, setOpenSections] = useState({});

  // Effect to handle section expansion based on selected item
  useEffect(() => {
    const newOpenSections = {};
    menuData.forEach((section) => {
      const hasSelectedItem = section.items.some(
        (item) => item.key === selectedKey
      );
      newOpenSections[section.title] = hasSelectedItem;
    });
    setOpenSections(newOpenSections);
  }, [selectedKey, menuData]);

  const toggleSection = (title) => {
    setOpenSections((prev) => ({ ...prev, [title]: !prev[title] }));
  };

  return (
    <div className="card card-section" style={{ height: "auto" }}>
      {menuData.map((section) => (
        <div
          key={section.title}
          style={{
            marginBottom: 24,
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "140%",
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              display: "flex",
              justifyContent: "space-between",
              cursor: section.collapsible ? "pointer" : "default",
            }}
            onClick={() => section.collapsible && toggleSection(section.title)}
          >
            <span
              style={{ color: "#000", fontSize: "14px", lineHeight: "140%" }}
            >
              {section.title}
            </span>{" "}
            {section.collapsible &&
              (openSections[section.title] ? (
                <img
                  style={{ width: "14px", height: "14px", cursor: "pointer" }}
                  src={minusIcon}
                  alt="minusIcon"
                />
              ) : (
                <img
                  style={{ width: "14px", height: "14px", cursor: "pointer" }}
                  src={plusIcon}
                  alt="plusIcon"
                />
              ))}
          </div>
          {(section.collapsible ? openSections[section.title] : true) && (
            <ul style={{ listStyle: "none", paddingLeft: 0 }}>
              {section.items.map((item) => (
                <li
                  className={`career-item ${
                    selectedKey === item.key ? "selected" : ""
                  }`}
                  key={item.key}
                  onClick={() => onSelect(item.key)}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default SideMenu;
